<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">电子班牌</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 90%" class="oneBodyImgCls" src="../../assets/images/bp4202_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">电子班牌</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          电子班牌是为了能够加强班级文化建设和班级风采展示，是专门为学校打造的一款关于班级文化展示的信息化产品，是专为老师、家长、孩子所打造的一个学习成长交流服务平台。平台整合了学校对外宣传、日常互动交流、教师教学办公、课外学习延伸、智能硬件接入等各种服务，让每一个校园自然形成智慧化教育应用智慧校园平台的数据呈现终端，也是智慧校园平台数据自动采集工具之一。通过电子班牌，呈现了班级文化的丰富多彩，同时也成为了学校和班级、教师和学生、家长和学生之间的互动媒介之一。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">526mm(长)*341mm(宽)*42mm(厚)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，学校，办公场所
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">通知<br/>公告</div>
        <div class="three_body_left_right">校园相关通告信息发布；当班牌长时间无人点击时，班牌自动切换成精简版首页，展示一些 班级介绍、通知公告、考场信息、当前科目、时间、天气等。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">学生<br/>信息</div>
        <div class="three_body_right_right" style="text-align: right">学生出入校、上课签到情况的刷卡考勤；可以查询自己每天的作业和老师对其的批复等等。
        </div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">教务<br/>管理</div>
        <div class="three_body_left_right">当日班级常规考试、班级课表等；班级学生和老师可以通过刷卡，人脸识别功能进行考勤签到。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">个性<br/>定制</div>
        <div class="three_body_right_right">显示模版可在模板库中配置，根据内容需求选择；根据班牌控制权限不同，配置不同管理人员进行内容管 理。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="width: 54%;margin: 32px 0" src="../../assets/images/bp4202_center_002.png"/>
    </div>

  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 360px;

    .oneBodyImgCls {
      width: 100%;
      height: 360px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 416px;

    .oneBodyImgCls {
      width: 100%;
      height: 416px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 541px;

    .oneBodyImgCls {
      width: 100%;
      height: 541px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>